module.exports = __webpack_public_path__ + "img/prestercito_lupa.35adb39d.svg";